import { css } from '@emotion/react'
import { Theme } from '@leroy-merlin-br/backyard-theme'

export const inputStyles = (theme: Theme) => css`
  label: chat-input;

  display: flex;
  height: 28px;
  min-height: 28px;
  max-height: 40px;
  padding: 8px 30px 8px 12px;
  align-items: flex-start;
  gap: ${theme.spacings.byte};
  flex-shrink: 0;
  border-radius: ${theme.borderRadius.giga};
  border: 1px solid ${theme.colors.n300};
  background: ${theme.colors.n100};

  color: ${theme.colors.n800};
  font-feature-settings: 'clig' off, 'liga' off;
  font-size: ${theme.typography.text.kilo.fontSize};
  font-weight: ${theme.font.weight.regular};
  line-height: ${theme.typography.text.kilo.fontSize};
  resize: none;
  overflow-y: hidden;

  &:focus,
  &:active {
    border: 1px solid ${theme.colors.n300};
  }
`

export const buttonStyles = (theme: Theme) => css`
  label: chat-form__button;

  pointer-events: all !important;
  cursor: pointer !important;
  height: 100% !important;
  width: 40px !important;
  padding: 0px !important;
  border: 0 !important;
  outline: none !important;

  &:hover,
  &:focus,
  &:focus-visible,
  &:active {
    color: ${theme.colors.n600} !important;
    background: transparent;
    border: none;
    box-shadow: none;
  }

  & svg {
    transform: rotate(30deg);
  }
`
